import {Verification} from '@sheerid/helpers';

(new Verification()).initialize();